import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import exact from 'prop-types-exact'
import {
  APPLICATION_INFORMATION_QUESTIONS,
  LEGAL_AND_MARKETING_FIELD_NAMES,
  MI_CERTIFICATE_TYPE
} from 'config'

const propTypes = {
  tenantApplication: Types.tenantApplication.isRequired,
  certType: PropTypes.string,
}

const defaultProps = {}

function ReviewApplicationInformation({ tenantApplication, certType }) {
  const skipsLegalAndMarketingApplicationInfo = certType !== MI_CERTIFICATE_TYPE
  return (
    <dl>
      {APPLICATION_INFORMATION_QUESTIONS.map(({ label, name }) => {
        if (
          skipsLegalAndMarketingApplicationInfo &&
          LEGAL_AND_MARKETING_FIELD_NAMES.has(name)
        ) {
          return null
        }

        const response = tenantApplication[name]
        if (!response) return null

        return (
          <React.Fragment key={label}>
            <dt>{label}</dt>
            <dd>{response}</dd>
          </React.Fragment>
        )
      })}
    </dl>
  )
}

ReviewApplicationInformation.propTypes = exact(propTypes)
ReviewApplicationInformation.defaultProps = defaultProps

export default React.memo(ReviewApplicationInformation)
